// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../css-loader/index.js!../../../../vue-loader/lib/loaders/stylePostLoader.js!../../../../postcss-loader/src/index.js!../../../../stylus-loader/index.js!../../../../style-resources-loader/lib/index.js??ref--3-4!./global.styl?vue&type=style&index=0&lang=stylus&");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("896bcf90", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../css-loader/index.js!../../../../vue-loader/lib/loaders/stylePostLoader.js!../../../../postcss-loader/src/index.js!../../../../stylus-loader/index.js!../../../../style-resources-loader/lib/index.js??ref--3-4!./global.styl?vue&type=style&index=0&lang=stylus&", function() {
     var newContent = require("!!../../../../css-loader/index.js!../../../../vue-loader/lib/loaders/stylePostLoader.js!../../../../postcss-loader/src/index.js!../../../../stylus-loader/index.js!../../../../style-resources-loader/lib/index.js??ref--3-4!./global.styl?vue&type=style&index=0&lang=stylus&");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}